import { render, staticRenderFns } from "./ProgressStatementsTable.vue?vue&type=template&id=061003e5"
import script from "./ProgressStatementsTable.vue?vue&type=script&lang=ts"
export * from "./ProgressStatementsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports